export const initialProspect = {
  Codigo: null,
  Descripcion: null,
  CodigoSecundario: null,
  Activo: true,
  Giro: null,
  VendedorPrincipal: null,
  VendedorSecundario: null,
  Clasificacion: null,
  CodigoClasificacion: null,
  CodigoVendedorPrincipal: null,
  CodigoVendedorSecundario: null,
  CodigoCondicionFiscal: null,
  CodigoEquivalente: null,
  LugaresEntrega: [],
  Contactos: [],
  IdentificacionFiscal: null,
};

export const Ejecutivo = {
  Apellido: null,
  Codigo: null,
  Nombre: null,
  Usuario: null,
  roles: [],
  roles_concat: null,
};

export const initial_filters = {
  Descripcion: null,
  CodigoSecundario: null,
  CodigoEjecutivo: null,
  Ejecutivo,
};
